import { useEffect, useMemo, useState } from 'react';
import { createChatTheme } from './chatTheme';
import type { ThemeMode } from './tokens';

const ATTR = 'data-shell-theme';

function readShellMode(): ThemeMode {
  if (typeof document === 'undefined') return 'light';
  const v = document.documentElement.getAttribute(ATTR);
  return v === 'dark' ? 'dark' : 'light';
}

/**
 * Подцепляет атрибут `data-shell-theme` с корня (его выставляет ThemeModeProvider
 * из AppShell). Это позволяет чату следовать общему тумблеру темы продукта.
 * Если атрибут не задан — light по умолчанию.
 */
export function useChatTheme() {
  const [mode, setMode] = useState<ThemeMode>(readShellMode);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    const obs = new MutationObserver(() => setMode(readShellMode()));
    obs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: [ATTR],
    });
    return () => obs.disconnect();
  }, []);

  const theme = useMemo(() => createChatTheme(mode), [mode]);
  return { theme, mode };
}
